import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const ClearSearch: Handler = props => {
    props.dispatch({
        type: "Custom/DiscrepancyHistory/ClearParameter",
    });
};

export const chain = [ClearSearch];

const clearDiscrepancySearch = createHandlerChainRunnerOptionalParameter(chain, {}, "clearDiscrepancySearch");
export default clearDiscrepancySearch;
